import type { InputHTMLAttributes } from 'react';

import { ClassNames } from '@/shared/classNames';

type InputProperties = InputHTMLAttributes<HTMLInputElement>;

export const Input = ({ className, ...properties }: InputProperties) => (
  <input
    className={ClassNames(
      'border-line bg-raised text-ink placeholder:text-muted/65 hover:border-line-strong focus:border-accent disabled:bg-sidebar disabled:text-muted min-h-10 w-full rounded-md border px-3 text-sm transition-colors disabled:cursor-not-allowed',
      className,
    )}
    {...properties}
  />
);
